import { atom } from 'recoil';
import { buildAuthzContext, extractGrantsFromUser, emptyGrants } from './buildAuthzContext';

function readInitialAuthzContext() {
  if (typeof window === 'undefined') {
    return buildAuthzContext(null, emptyGrants());
  }

  try {
    const raw = localStorage.getItem('userInfo');
    const userInfo = raw ? JSON.parse(raw) : null;
    return buildAuthzContext(userInfo, extractGrantsFromUser(userInfo));
  } catch {
    return buildAuthzContext(null, emptyGrants());
  }
}

/** @type {import('recoil').RecoilState<import('./types/authz.types').AuthzContext>} */
export const authzContextAtom = atom({
  key: 'authzContextAtom',
  default: readInitialAuthzContext(),
});
